// extracted by mini-css-extract-plugin
export default {"save-indicator":"styles__save-indicator--TG3XK","white-background":"styles__white-background--BVINA","is-saved":"styles__is-saved--u2oAH","disabled":"styles__disabled--o4OBD"};